import {
  ANDROID_INSTALL_PREFERENCE_KEY,
  ANDROID_INSTALL_SUPPRESSION_MS,
  isAndroidAppAudience,
  isAndroidInstallSuppressed,
} from "./android-install-policy.mjs";

let memorySuppressedUntil = 0;

/** Platform hints stay on this device; they are never sent to analytics. */
export function isAndroidBrowserAudience(): boolean {
  if (typeof navigator === "undefined" || typeof window === "undefined") return false;
  const browser = navigator as Navigator & {
    userAgentData?: { platform?: string };
    standalone?: boolean;
  };
  return isAndroidAppAudience({
    platform: browser.userAgentData?.platform,
    userAgent: browser.userAgent,
    standalone:
      browser.standalone === true || window.matchMedia?.("(display-mode: standalone)").matches,
  });
}

export function hasAndroidWebPreference(): boolean {
  if (isAndroidInstallSuppressed(memorySuppressedUntil)) return true;
  try {
    return isAndroidInstallSuppressed(window.localStorage.getItem(ANDROID_INSTALL_PREFERENCE_KEY));
  } catch {
    return false;
  }
}

/** A dismissal or explicit web choice buys seven quiet days, without an ID. */
export function rememberAndroidWebPreference(): void {
  memorySuppressedUntil = Date.now() + ANDROID_INSTALL_SUPPRESSION_MS;
  try {
    window.localStorage.setItem(ANDROID_INSTALL_PREFERENCE_KEY, String(memorySuppressedUntil));
  } catch {
    // Keep the choice for this tab even when durable browser storage is denied.
  }
}
